<div class="flex items-center justify-center min-h-screen p-4 ">

  <div class="p-3 rounded-3xl bg-white text-center mx-auto max-w-[600px]">
    <img class="mb-5 mx-auto" [ngSrc]="'assets/img/logo.svg'" alt="" width="80" height="33">
    <h3 class="text-2xl font-bold mb-3">This is an adult website</h3>
    <p class="mb-3">
      This website contains age-restricted materials including nudity and explicit depictions of sexual activity. By entering, you affirm that you are at least 18 years of age or the age of majority in the jurisdiction you are accessing the website from and you consent to viewing sexually explicit content.
    </p>

    <div class="rounded-2xl bg-[#EDF0F3] text-[#2A3447] text-sm p-3 mb-3 text-left">
      <p class="font-bold mb-1">AI-generated content</p>
      <p>
        All characters and media on this site are generated by artificial intelligence and do not depict real people. All depicted individuals are represented as adults (18+).
        <a class="font-bold underline" routerLink="/documents/ai-disclosure">Learn more</a>.
      </p>
    </div>

    <div class="max-[500px]:flex-col! flex flex-row gap-3 justify-center items-center mb-3 ">
      <button class="cursor-pointer rounded-full font-bold p-2 w-full max-w-60 mx-auto text-white! bg-red-500" (click)="onClick('agree')">I am 18 or older - Enter</button>
      <button class="cursor-pointer rounded-full font-bold p-2 w-full max-w-60 mx-auto text-white! bg-[#8799B2]" (click)="onClick('decline')">I am under 18 - Exit</button>
    </div>

    <p class="mb-3">
      Our parental controls page explains how you can easily
      block access to this site.
    </p>

    <p class="text-sm text-[#8799B2] flex flex-row justify-center flex-wrap gap-x-3 gap-y-1 mb-3">
      <a routerLink="/documents/terms">Terms of use</a>
      <a routerLink="/documents/privacy">Privacy policy</a>
      <a routerLink="/documents/2257">2257 Statement</a>
      <a routerLink="/documents/content-policy">Content policy</a>
      <a routerLink="/documents">All documents</a>
    </p>

    <p class="text-xs text-[#8799B2]">
      © 2026 SENS LTD. Seychelles, registration number 239563.<br>All rights reserved.
    </p>
  </div>
</div>
